import React, { useState, useEffect } from 'react';
import {useTranslation} from 'react-i18next';
import Margin from '../../../components/shared/margin';
import Head from '../../../components/shared/head';
import {commonStyles as stylesCommon} from '../../../styles/common';
import {useSelector} from 'react-redux';
import LayoutContent from '../../../components/layouts/content2';
import { styles } from './styles';
import {useNavigate, useLocation} from 'react-router-dom';
import { Link } from 'react-router-dom';


function Index() {
    const data = useLocation().state;
    const urlSegments = window.location.pathname.split('/');
    const categorie_id = urlSegments[urlSegments.length - 1];

    const navigate = useNavigate();
    const {allmenu} = useSelector((state) => state.initLoad);
    
    const commonStyles  = stylesCommon(); 
    
    const {t, i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menu, setMenu] = useState([]);
    const [titleCategorie, setIitleCategorie] = useState('');

    
    return (
        <LayoutContent>
            <div style={styles.content}>
                <Head title={titleCategorie} />
                <Margin top={15} />
                <div style={{...{paddingInline: 20, position: 'relative'}}}>
                    <div
                        className='itemdrinks'
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingHorizontal: 20,
                        }}>
                            
                        <Link
                            to={'/subdrinks'}
                            state={{type: 'mexicam'}}
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                resizeMode: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                                    fontWeight: 'bold',
                                color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                width: '60%',
                                textAlign: 'center',
                                textTransform: 'uppercase'
                                }}>
                                Mexican Sodas
                            </p>
                        </Link>
                        <Link to={'/subdrinks'}
                            state={{type: 'aguanatural'}} style={{display: 'flex',justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                resizeMode: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                                    fontWeight: 'bold',
                                color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                    width: '60%',
                                textTransform: 'uppercase',
                                    textAlign: 'center',
                               
                                }}>
                                Aguas Naturales
                            </p>
                        </Link>
                        
                    </div>

                    <div
                        className='itemdrinks'
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingHorizontal: 20,
                        }}>
                            
                        <Link
                            to={'/subdrinks'}
                            state={{ type: 'jugosnatural' }}
                            
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                resizeMode: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                                    fontWeight: 'bold',
                                color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                    width: '60%',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                }}>
                                 jugos naturales
                            </p>
                        </Link>
                        <Link
                            to={'/subdrinks'}
                            state={{ type: 'batidos' }}
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                resizeMode: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                                    fontWeight: 'bold',
                                color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                width: '60%',
                                    textAlign: 'center',
                                 textTransform: 'uppercase'
                                }}>
                                 batidos saludables
                            </p>
                        </Link>
                        
                    </div>

                    <div
                        className='itemdrinks'
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingHorizontal: 20,
                        }}>
                            
                        <Link
                            to={'/subdrinks'}
                            state={{ type: 'limonadas' }}
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                resizeMode: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                                    fontWeight: 'bold',
                                color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                    width: '60%',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                }}>
                               limonadas
                            </p>
                        </Link>
                        <Link
                                to={'/subdrinks'}
                            state={{ type: 'hotdrink' }}
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                resizeMode: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                                    fontWeight: 'bold',
                                color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                width: '60%',
                                    textAlign: 'center',
                                 textTransform: 'uppercase'
                                }}>
                                bebidas calientes
                            </p>
                        </Link>
                        
                    </div>

                </div>
            </div>
            <Margin top={15} />
        </LayoutContent>
    );
}

export default Index;